import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'
import {
  NotificationPayload,
  showNotification,
} from '../../../../features/notifications'
import { GiftOrderDetail, GiftOrderStatus } from './types'
import { EGiftOrderStatusesCodes } from '../const'

export const giftOrderMounted = createEvent()

export const setGiftOrder = createEvent<GiftOrderDetail>()

export const $giftOrder = restore(setGiftOrder, {
  id: 0,
  orderDate: '',
  clientId: 0,
  client: {
    clientId: 0,
    crown: '',
    fullName: '',
    tsname: '',
  },
  gift: {
    id: 0,
    name: '',
    title: '',
    giftType: '',
  },
  giftId: 0,
  giftPrice: 0,
  deliveryInfo: {
    address: '',
    contact_number: '',
    country: '',
    first_name: '',
    last_name: '',
    postal_code: '',
    size: '',
  },
  fileName: '',
  fileUrl: '',
  status: '',
  managerComment: '',
})
export const getGiftOrder = fx<void, GiftOrderDetail>({
  method: 'GET',
  url: '/giftshop/gift_order/',
})

export const submitGiftOrderStatus = fx<{ status: number }, GiftOrderDetail>({
  method: 'PUT',
  url: `/giftshop/gift_order/`,
})

sample({
  clock: giftOrderMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.giftOrderID
    }
    return {
      url: `/giftshop/gift_order/${id}`,
      query: {
        populate: JSON.stringify(['Gift.giftType']),
      },
    }
  },
  target: getGiftOrder,
})

sample({
  clock: [getGiftOrder.doneData],
  fn: (doneData) => doneData.body,
  target: [setGiftOrder],
})

sample({
  clock: [getGiftOrder.failData, submitGiftOrderStatus.failData],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: submitGiftOrderStatus.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Gift order status updated',
  }),
  target: showNotification,
})
